<script>
  import Swal from "sweetalert2";
  import {
    Button,
    Modal,
    ModalBody,
    ModalFooter,
    ModalHeader,
    Input,
    Spinner
  } from "sveltestrap";
  export let open;
  export let toggle;
  export let newdate;
  export let staffid;

  let reason = "";
  let rejecting = false;

  async function submitReject() {
    rejecting = true;
    const data = {
      startWeek: newdate,
      staffid: staffid,
      reason: reason
    };
    const res = await fetch("/timesheetapi/RejectTimesheet", {
      method: "POST",
      headers: {
        "Content-type": "application/json"
      },
      body: JSON.stringify(data)
    });
    const status = await res.status;
    rejecting = false;
    open = false;
    if (status === 200) {
      Swal.fire({
        icon: 'error',  
        title: 'Timesheet rejected',
        showConfirmButton: false,
        timer: 2000
      });
      document.getElementById("btn-search").click();
    }
  }

  function handleChangeReason(e) {
    reason = e.target.value;
  }

  function handleSubmit() {
    submitReject();
    reason = "";
  }
</script>

<style>

</style>

<Modal isOpen={open} {toggle} transition="fade">
  <ModalHeader {toggle}>Reject Timesheet</ModalHeader>
  <ModalBody>
    <Input
      style="height: 120px"
      type="textarea"
      name="text"
      bind:value={reason}
      placeholder="Write your reason (Optional)" />
  </ModalBody>
  <ModalFooter>
    {#if rejecting}
      <Button
        color="danger"
        style="cursor: not-allowed; opacity: 0.5"
        on:click={handleSubmit}
        disabled>
        <Spinner size="sm" />
        Rejecting
      </Button>
    {:else}
      <Button color="danger" on:click={handleSubmit}>Reject</Button>
    {/if}
    <Button color="secondary" on:click={toggle}>Cancel</Button>
  </ModalFooter>
</Modal>
